import { FC, useState } from 'react';
import OnFarmPaymentHistory from './OnFarmPaymentHistory';
import OnFarmStorageRates from './OnFarmStorageRates';
import { LABEL_CONSTANTS, NAVIGATION_LINK_CONSTANTS } from '../../../constants/common';
import './onFarmSettings.scss';

const OnFarmSettings: FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="on-farm on-farm-settings">
      <div className="on-farm-action card">
        <div className="deposit-header">
          <h1>{NAVIGATION_LINK_CONSTANTS.SETTINGS}</h1>
        </div>

        <div className="manage-billing-information">
          <h4 className="top-header">{LABEL_CONSTANTS.MANAGE_YOUR_BILLING}</h4>
          <div className="manage-billing-info__header">
            <ul className="manage-billing-info__tabs">
              <li className={activeTab === 0 ? 'active' : ''} onClick={() => setActiveTab(0)}>
                {LABEL_CONSTANTS.STORAGE_RATES}
              </li>
              <li className={activeTab === 1 ? 'active' : ''} onClick={() => setActiveTab(1)}>
                {LABEL_CONSTANTS.PAYMENT_HISTORY}
              </li>
            </ul>
          </div>

          <div className="manage-billing-info__body">
            {activeTab === 0 && <OnFarmStorageRates />}
            {activeTab === 1 && <OnFarmPaymentHistory />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnFarmSettings;
